import { AnalyticsSummary } from '../../domain/analytics/AnalyticsSummary';
import { AnalyticsSummaryEntry } from '../../entries/AnalyticsSummaryEntry';

export class AnalyticsSummaryMapper {
  static toDomain(props: AnalyticsSummaryEntry): AnalyticsSummary {
    const { start_date, end_date, completed_stops, incomplete_stops, canceled_stops, total_km, total_emissions } =
      props;

    return AnalyticsSummary.create({
      start_date,
      end_date,
      completed_stops,
      canceled_stops,
      incomplete_stops,
      total_km,
      total_emissions,
    });
  }
}
